import { H2 } from "components/shared/Heading";
import styled from "styled-components";

export const HeroSubtitle = styled(H2)`
    color: white;
    background-color: rgba(0, 0, 0, 0.5);
    text-transform: uppercase;
    width: fit-content;
    padding: 8px 16px;
`;
